(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atlas-black-november"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atlas-bn-countdown')) {
    customElements.define('atlas-bn-countdown', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        const end = Date.parse(this.dataset.endTime || '');
        if (!Number.isFinite(end)) {
          this.closest('.bn-countdown-wrap').hidden = true;
          return;
        }
        const units = this.querySelectorAll('[data-bn-unit]');
        const render = () => {
          const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
          if (seconds <= 0) {
            this.textContent = this.dataset.finishedText || '';
            this.classList.add('bn-offer-ended');
            const label = this.parentElement.querySelector('.bn-countdown-label');
            if (label) label.hidden = true;
            this.stop();
            return false;
          }
          const parts = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
          units.forEach((unit, i) => { unit.textContent = String(parts[i]).padStart(2, '0'); });
          return true;
        };
        if (render()) this.timer = window.setInterval(render, 1000);
      }
      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
      disconnectedCallback() { this.stop(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
